import React, { createContext, useState } from "react";
import { useLocation, useSearchParams } from "react-router";

export interface INavLinks {
  "/sponsorships": string;
  "/media-rates": string;
  "/users": string;
}

export interface INavContext {
  navLinks: INavLinks;
  updateNavLink: (link: keyof INavLinks, value: string) => void;
}

export const defaultNavContext = {
  navLinks: {
    "/sponsorships": "/sponsorships",
    "/media-rates": "/media-rates",
    "/users": "/users",
  },
  updateNavLink: (link: keyof INavLinks, value: string) => {},
};

export const NavContext = createContext<INavContext>(defaultNavContext);

export const links: {
  href: keyof INavLinks;
  label: string;
  adminOnly: boolean;
}[] = [
  {
    href: "/sponsorships",
    label: "Sponsorships",
    adminOnly: false,
  },
  {
    href: "/media-rates",
    label: "Media rates",
    adminOnly: false,
  },
  {
    href: "/users",
    label: "Users",
    adminOnly: true,
  },
];

export const NavParent = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const pathname = location.pathname as keyof INavLinks;
  const [searchParams] = useSearchParams();
  const [navLinks, setNavLinks] = useState<INavLinks>({
    ...defaultNavContext.navLinks,
    [pathname]: `${pathname}?${searchParams.toString()}`,
  });
  return (
    <NavContext.Provider
      value={{
        navLinks,
        updateNavLink: (link, value) => {
          setNavLinks({
            ...navLinks,
            [link]: value,
          });
        },
      }}
    >
      {children}
    </NavContext.Provider>
  );
};
